import {AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn} from "@angular/forms"
import {
  SezIIAccertamentoHelpers
} from "app/features/revisione53/features/sez-II-accertamento/shared/helpers/sez-II-accertamento.helpers";
import {isEqual} from "lodash-es";
import * as _ from 'lodash';


const my_CkAderenteAII = (form: FormGroup) => {
    const my_ElAderentiAII = form.get('my_SezioneII__Accertamento.my_AderentiAII.my_ElAderentiAII') as FormArray;

    my_ElAderentiAII.controls
    .map(e => {
        const my_CkAderenteAII = e.get('my_SezVisibAderenteAII.my_CkAderenteAII');
        const my_aderenteDalII = e.get('my_SezVisibAderenteAII.my_aderenteDalII').value;
        let errors = my_CkAderenteAII.errors ? my_CkAderenteAII.errors : {};

        if(my_CkAderenteAII.value != true && my_aderenteDalII) {
            Object.assign(errors,{
                my_CkAderenteAII: {
                    status: "my_CkAderenteAII.value != '1' && my_aderenteDalII != ''",
                    message: 'Campo obbligatorio'
                }
            })
        }

        my_CkAderenteAII.setErrors(isEqual(errors, {}) ? null : errors);
    })
}

const my_aderenteDalII = (form: FormGroup) => {
    const my_ElAderentiAII = form.get('my_SezioneII__Accertamento.my_AderentiAII.my_ElAderentiAII') as FormArray;

    my_ElAderentiAII.controls
    .map(e => {
        const my_aderenteDalII = e.get('my_SezVisibAderenteAII.my_aderenteDalII');
        const my_CkAderenteAII = e.get('my_SezVisibAderenteAII.my_CkAderenteAII').value;
        let errors = my_aderenteDalII.errors ? my_aderenteDalII.errors : {};

        if(my_CkAderenteAII === true && !my_aderenteDalII?.value) {
            Object.assign(errors,{
                my_aderenteDalII: {
                    status: "my_CkAderenteAII === '1' && my_aderenteDalII.value === ''",
                    message: 'Campo obbligatorio'
                }
            })
        }

        my_aderenteDalII.setErrors(isEqual(errors, {}) ? null : errors);
    })
}

const my_AltroAllegatoAcceramentoElementDesc = (form: FormGroup) => {
    const my_AltroAllegatoAccertamento: FormArray = form.get('my_SezioneII__Accertamento.my_AltriAllegatiAccertamento.my_AltroAllegatoAccertamento') as FormArray;

    my_AltroAllegatoAccertamento.controls
    .map(element => {
        const my_AltroAllegatoAcceramentoElementDescControl = element.get('my_AltroAllegatoAcceramentoElementDesc');
        const my_AltroAllegatoAccertamentoElement = element.get('my_AltroAllegatoAccertamentoElement').value;
        let errors = my_AltroAllegatoAcceramentoElementDescControl.errors ? my_AltroAllegatoAcceramentoElementDescControl.errors : {};

        if(my_AltroAllegatoAcceramentoElementDescControl.value === '' && my_AltroAllegatoAccertamentoElement != '') {
            Object.assign(errors,{
                my_AltroAllegatoAcceramentoElementDesc: {
                    status: "my_AltroAllegatoAcceramentoElementDescControl.value === '' && my_AltroAllegatoAccertamentoElement != ''",
                    message: 'Campo obbligatorio'
                }
            })
        }

        my_AltroAllegatoAcceramentoElementDescControl.setErrors(isEqual(errors, {}) ? null : errors);
    })

}

const my_ckNominaLiqAssSociII = (form: FormGroup) => {
    const my_ckNominaLiqAssSociIIControl = form.get('my_SezioneII__Accertamento.my_SchedaPropostaSostLiquidCancelRegImpreII.my_ckNominaLiqAssSociII');
    const my_CkProvvedimendoDiII = form.get('my_SezioneII__Accertamento.my_CkProvvedimendoDiII').value;
    const my_ckNominaLiqAutGiudII = form.get('my_SezioneII__Accertamento.my_SchedaPropostaSostLiquidCancelRegImpreII.my_ckNominaLiqAutGiudII').value;

    let errors = my_ckNominaLiqAssSociIIControl.errors ? my_ckNominaLiqAssSociIIControl.errors : {};

    if(!my_ckNominaLiqAssSociIIControl.value && my_CkProvvedimendoDiII === '4' && !my_ckNominaLiqAutGiudII) {
        Object.assign(errors,{
            my_ckNominaLiqAssSociII: {
                status: "Campo obbligatorio",
                message: 'Campo obbligatorio'
            }
        });
    }

    my_ckNominaLiqAssSociIIControl.setErrors(isEqual(errors, {}) ? null : errors);
}

const my_ckNominaLiqAutGiudII = (form: FormGroup) => {
    const my_ckNominaLiqAutGiudIIControl = form.get('my_SezioneII__Accertamento.my_SchedaPropostaSostLiquidCancelRegImpreII.my_ckNominaLiqAutGiudII');
    const my_CkProvvedimendoDiII = form.get('my_SezioneII__Accertamento.my_CkProvvedimendoDiII').value;
    const my_ckNominaLiqAssSociII = form.get('my_SezioneII__Accertamento.my_SchedaPropostaSostLiquidCancelRegImpreII.my_ckNominaLiqAssSociII').value;

    let errors = my_ckNominaLiqAutGiudIIControl.errors ? my_ckNominaLiqAutGiudIIControl.errors : {};

    if(!my_ckNominaLiqAutGiudIIControl.value && my_CkProvvedimendoDiII === '4' && !my_ckNominaLiqAssSociII) {
        Object.assign(errors,{
            my_ckNominaLiqAutGiudII: {
                status: "Campo obbligatorio",
                message: 'Campo obbligatorio'
            }
        });
    }

    my_ckNominaLiqAutGiudIIControl.setErrors(isEqual(errors, {}) ? null : errors);
}

const my_descRisultanzeBilII = (form: FormGroup) => {
    const my_descRisultanzeBilIIControl = form.get('my_SezioneII__Accertamento.my_SchedaPropostaSostLiquidCancelRegImpreII.my_descRisultanzeBilII');
    const my_CkProvvedimendoDiII = form.get('my_SezioneII__Accertamento.my_CkProvvedimendoDiII').value;

    let errors = my_descRisultanzeBilIIControl.errors ? my_descRisultanzeBilIIControl.errors : {};

    if(my_descRisultanzeBilIIControl.value === '' && my_CkProvvedimendoDiII === '9') {
        Object.assign(errors,{
            my_descRisultanzeBilII: {
                status: "my_descRisultanzeBilII === '' && my_CkProvvedimendoDiII === '9'",
                message: 'Campo obbligatorio'
            }
        })
    }

    else if(my_descRisultanzeBilIIControl.value === '' && my_CkProvvedimendoDiII === '4') {
        Object.assign(errors,{
            my_descRisultanzeBilII: {
                status: "Campo obbligatorio",
                message: 'Campo obbligatorio'
            }
        })
    }

    my_descRisultanzeBilIIControl.setErrors(isEqual(errors, {}) ? null : errors);
}

const my_descNominaLiqII = (form: FormGroup) => {
    const my_descNominaLiqIIControl = form.get('my_SezioneII__Accertamento.my_SchedaPropostaSostLiquidCancelRegImpreII.my_descNominaLiqII');
    const my_CkProvvedimendoDiII = form.get('my_SezioneII__Accertamento.my_CkProvvedimendoDiII').value;
    const my_ckNominaLiqAssSociII = form.get('my_SezioneII__Accertamento.my_SchedaPropostaSostLiquidCancelRegImpreII.my_ckNominaLiqAssSociII').value;
    const my_ckNominaLiqAutGiudII = form.get('my_SezioneII__Accertamento.my_SchedaPropostaSostLiquidCancelRegImpreII.my_ckNominaLiqAutGiudII').value;

    let errors = my_descNominaLiqIIControl.errors ? my_descNominaLiqIIControl.errors : {};

    if(!my_descNominaLiqIIControl.value && my_CkProvvedimendoDiII === '4' && (my_ckNominaLiqAssSociII || my_ckNominaLiqAutGiudII)) {
        Object.assign(errors,{
            my_descNominaLiqII: {
                status: "Campo obbligatorio",
                message: 'Campo obbligatorio'
            }
        })
    }

    my_descNominaLiqIIControl.setErrors(isEqual(errors, {}) ? null : errors);
}

const my_descAzAvviateII = (form: FormGroup) => {
    const my_descAzAvviateIIControl = form.get('my_SezioneII__Accertamento.my_SchedaPropostaLiqCoattaII.my_descAzAvviateII');
    const my_CkProvvedimendoDiII = form.get('my_SezioneII__Accertamento.my_CkProvvedimendoDiII').value;

    const my_ckAvvIstanzaFallII = form.get('my_SezioneII__Accertamento.my_SchedaPropostaLiqCoattaII.my_ckAvvIstanzaFallII').value;
    const my_ckAvvDecrIngiuntII = form.get('my_SezioneII__Accertamento.my_SchedaPropostaLiqCoattaII.my_ckAvvDecrIngiuntII').value;
    const my_ckAvvAzEsecII = form.get('my_SezioneII__Accertamento.my_SchedaPropostaLiqCoattaII.my_ckAvvAzEsecII').value;
    const my_ckAvvProtestiII = form.get('my_SezioneII__Accertamento.my_SchedaPropostaLiqCoattaII.my_ckAvvProtestiII').value;
    const my_ckAvvAltroII = form.get('my_SezioneII__Accertamento.my_SchedaPropostaLiqCoattaII.my_ckAvvAltroII').value;

    let errors = my_descAzAvviateIIControl.errors ? my_descAzAvviateIIControl.errors : {};

    const orCondition: boolean = (my_ckAvvIstanzaFallII || my_ckAvvDecrIngiuntII || my_ckAvvAzEsecII || my_ckAvvProtestiII || my_ckAvvAltroII);

    if(!my_descAzAvviateIIControl.value && my_CkProvvedimendoDiII === '5' && orCondition) {
        Object.assign(errors,{
            my_descAzAvviateII: {
                status: "my_descAzAvviateIIControl.value === '' && my_CkProvvedimendoDiII === '5' && my_ckAvvIstanzaFallII === '1'",
                message: 'Campo obbligatorio'
            }
        })
    }

    my_descAzAvviateIIControl.setErrors(isEqual(errors, {}) ? null : errors);
}

export const liquidazioneDefaultValidator = (fieldName: string): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const my_CkProvvedimendoDiII = control?.parent?.parent?.get('my_CkProvvedimendoDiII')?.value;
    let error = null;
    if ((_.isNil(control?.value) || control?.value === false || control?.value === '') && my_CkProvvedimendoDiII === '5') {
      error = {};
      error[fieldName] = {
        status: 'Campo obbligatorio',
        message: 'Campo obbligatorio',
      };
    }
    return error;
  }
}

export const liquidazioneDefaultDescValidator = (fieldName: string, checkFieldName: string, checkValue: string = '0'): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors => {
    const my_CkProvvedimendoDiII = control?.parent?.parent?.get('my_CkProvvedimendoDiII')?.value;
    const checkFieldValue = control?.parent?.get(checkFieldName)?.value;
    let error = null;
    if ((_.isNil(control?.value) || control?.value === '') && my_CkProvvedimendoDiII === '5' && checkFieldValue === checkValue) {
      error = {};
      error[fieldName] = {
        status: 'Campo obbligatorio',
        message: 'Campo obbligatorio'
      }
    }
    return error;
  }
}

const my_CodFiscII = (form: FormGroup) => {
    const my_CodFiscIIControl = form.get("my_SezioneII__Accertamento.my_CodFiscII");

    let errors = my_CodFiscIIControl.errors ? my_CodFiscIIControl.errors : {};

    const check = my_CodFiscIIControl.value.includes('00000000000');

    if (check) {
      Object.assign(errors,{
        my_CodFiscIIControl: {
          status: "check = true",
          message: "Valore non valido"
        }
      })
    }
    else if(my_CodFiscIIControl.value.length != 11) {
      Object.assign(errors,{
        my_CodFiscIIControl: {
          status: "Lunghezza diversa da 11 caratteri",
          message: "La lunghezza del codice fiscale non è corretta. Il codice fiscale deve essere lungo 11 caratteri"
        }
      })
    }
    else{
      // Funzione presa da http://www.icosaedro.it/cf-pi/

      let somma = 0;
      for(let index = 0; index < 11; index++){
        let somma1 = my_CodFiscIIControl.value.charCodeAt(index) - "0".charCodeAt(0);

        if( (index & 1) === 1) {
          somma1 = somma1*2;
          if(somma1 > 9) {
            somma1 = somma1 - 9;
          }
        }
        somma = somma + somma1;
      }
      if(somma%10 !== 0) {
        Object.assign(errors,{
            my_CodFiscIIControl: {
            status: "Codice fiscale errato",
            message: "Il codice fiscale non è valido"
          }
        })
      }

    }

    my_CodFiscIIControl.setErrors(isEqual(errors, {}) ? null : errors);
  }

  export const my_NIscrizRevis = (control: AbstractControl): ValidationErrors | null => {
    if (!control?.value) {
      return {
        my_NIscrizRevis: {
          message: 'Il campo deve essere inserito obbligatoriamente',
          status: 'Campo Obbligatorio'
        }
      }
    } else if (control?.value?.startsWith('/')) {
      return {
        my_NIscrizRevis: {
          message: 'Se il campo non è caricato in automatico, comunicare al Servizio Nazionale tale numero',
          status: 'Inserire il numero di iscrizione presso l\'elenco del Ministero'
        }
      }
    }
    return null;
  }

  const my_PartitaIVAII = (form: FormGroup) => {
    const my_PartitaIVAIIControl = form.get('my_SezioneII__Accertamento.my_PartitaIVAII');

    let errors = my_PartitaIVAIIControl.errors ? my_PartitaIVAIIControl.errors : {};

    const check = my_PartitaIVAIIControl.value.includes('00000000000');

    if (check) {
      Object.assign(errors,{
        my_PartitaIVAIIControl: {
          status: "check = true",
          message: "Valore non valido"
        }
      })
    }
    else if(my_PartitaIVAIIControl.value.length != 11) {
      Object.assign(errors,{
        my_PartitaIVA: {
          status: "Lunghezza diversa da 11 caratteri",
          message: "La lunghezza della partita IVA non è corretta. La partita IVA deve essere lunga 11 caratteri"
        }
      })
    }
    else{
      // Funzione presa da http://www.icosaedro.it/cf-pi/

      let somma = 0;
      for(let index = 0; index < 11; index++){
        let somma1 = my_PartitaIVAIIControl.value.charCodeAt(index) - "0".charCodeAt(0);

        if( (index & 1) === 1) {
          somma1 = somma1*2;
          if(somma1 > 9) {
            somma1 = somma1 - 9;
          }
        }
        somma = somma + somma1;
      }
      if(somma%10 !== 0) {
        Object.assign(errors,{
          my_PartitaIVA: {
            status: "partita IVA errata",
            message: "La partita IVA non è valida"
          }
        })
      }
      else {
        return;
      }
    }

    my_PartitaIVAIIControl.setErrors(isEqual(errors, {}) ? null : errors);
  }

const my_RappresentanteCoopCodFiscII = (form: FormGroup) => {
    const my_RappresentanteCoopCodFiscII = form.get('my_SezioneII__Accertamento.my_RappresentanteCoopCodFiscII');
    const my_RappresentanteCoopNomeII = form.get('my_SezioneII__Accertamento.my_RappresentanteCoopNomeII').value;
    const my_RappresentanteCoopCognomeII = form.get('my_SezioneII__Accertamento.my_RappresentanteCoopCognomeII').value;

    SezIIAccertamentoHelpers.validaCodiceFiscale(my_RappresentanteCoopNomeII,my_RappresentanteCoopCognomeII,my_RappresentanteCoopCodFiscII);
}


export const SezIIAccertamentoFormValidators = [
    my_CkAderenteAII,
    my_aderenteDalII,
    my_AltroAllegatoAcceramentoElementDesc,
    my_ckNominaLiqAssSociII,
    my_ckNominaLiqAutGiudII,
    my_descRisultanzeBilII,
    my_descNominaLiqII,
    my_descAzAvviateII,
    my_CodFiscII,
    my_PartitaIVAII,
    my_RappresentanteCoopCodFiscII
]
